import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { AppConfigDirective } from './app-config.directive';
import { AppConfigurationProperties, AppConfigurationPropertiesService } from './app-configuration-properties.interface';

@NgModule({
	imports: [CommonModule],
	declarations: [
		AppConfigDirective
	],
	exports: [AppConfigDirective]
})
export class AppConfigurationModule {
	public static withOptions(properties: AppConfigurationProperties): ModuleWithProviders<AppConfigurationModule> {
		return {
			ngModule: AppConfigurationModule,
			providers: [
				{
					provide: AppConfigurationPropertiesService,
					useValue: properties
				}
			]
		};
	}
}
